import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from 'assets/locales/en/translation.json';
import es from 'assets/locales/es/translation.json';
import { LanguageCode } from 'enums';
import { NODE_ENV } from 'constants/node-env';

const resources = {
  en,
  es
};

if (process.env.NODE_ENV === NODE_ENV.TEST) {
  i18n.use(LanguageDetector);
}

i18n.use(initReactI18next).init({
  resources,
  defaultNS: 'common',
  fallbackLng: LanguageCode.EN,
  // React already escapes interpolated values in JSX; i18next's default
  // escape turns `'` into literal `&#39;` in plain-text children.
  interpolation: { escapeValue: false },
  detection: {
    order: ['cookie', 'htmlTag', 'path', 'subdomain'],
    caches: ['cookie']
  }
});

export const availableLanguages = Object.keys(resources);

export const t = (
  key: string,
  options?: Record<string, string | number | boolean>
): string => {
  if (!i18n.isInitialized) {
    return key;
  }
  return i18n.t(key, options ?? {}) as unknown as string;
};

export const changeLanguage = async (lng: string): Promise<void> => {
  try {
    await i18n.changeLanguage(lng);
  } catch (error) {
    console.error('Failed to change language:', error);
  }
};

export default i18n;
